<template>
  <el-dialog
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    width="430"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
          新网银行短验证
        </h4>
      </div>
    </template>

    <el-form
      ref="formRef"
      :model="formValues"
      :rules="rules"
    >
      <div class="flex flex-col w-[98%] pl-2">
        <el-form-item>
          <template #label>
            <span class="inline-block w-[80px]">验证人</span>
          </template>
          <span>{{ data.bankOpeningSmsAuthContactName }}</span>
        </el-form-item>
        <el-form-item>
          <template #label>
            <span class="inline-block w-[80px]">验证手机号</span>
          </template>
          <span>{{ data.bankOpeningSmsAuthContactMobile }}</span>
        </el-form-item>
        <el-form-item prop="code" class="rerlative">
          <template #label>
            <span class="inline-block w-[72px]">验证码</span>
          </template>

          <el-input
            v-model="formValues.code"
            style="width: 172px"
            size="large"
            placeholder="请输入验证码"
            @keyup.enter="onConfirm"
          >
            <template #prefix>
              <svg-icon icon="lucide:shield-check" />
            </template>
          </el-input>

          <sms-button
            ref="smsBtnRef"
            class="left-auto right-0"
            @click="sendSms"
          />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="flex justify-center">
        <el-button @click="emit('close')">
          取消
        </el-button>
        <el-button type="primary" @click="onConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { SmsButton, SvgIcon } from '@vue3/components';
import { IYibaoBaseInfo } from '@core/main/types';
import { ElMessage, FormInstance, FormRules } from 'element-plus';
import { computed, nextTick, PropType, ref, watchEffect } from 'vue';
import { checkSmsCode } from '@core/tools';
import { ESmsType, sendSmscode } from '@core/api';

let sendSmsLock = false;

const emit = defineEmits(['close', 'submit']);

const formRef = ref<FormInstance>();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object as PropType<IYibaoBaseInfo>,
    default() {
      return {};
    },
  },
});

const rules = computed<FormRules<{ code: string }>>(() => {
  return {
    code: [
      {
        required: true,
        validator: (rule: any, value: string, callback: any) => {
          if (checkSmsCode(String(formValues.value.code))) {
            callback(checkSmsCode(String(formValues.value.code)));
          }
          callback();
        },
      },
    ],
  };
});

const smsBtnRef = ref<InstanceType<typeof SmsButton>>(null);
const formValues = ref({} as IYibaoBaseInfo & { code: string });

async function sendSms() {
  if (sendSmsLock) return;

  try {
    sendSmsLock = true;
    smsBtnRef.value?.showLoading();
    await sendSmscode(ESmsType.EditPass, props.data.bankOpeningSmsAuthContactMobile); // TODO

    smsBtnRef.value?.countdown();
  } catch (error) {
    smsBtnRef.value?.hideLoading();
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  setTimeout(() => {
    sendSmsLock = false;
  }, 1300);
}

const onConfirm = async () => {
  const valid = await validate();

  if (!valid) return;

  emit('submit', formValues.value.code);
};

async function validate(callback?: () => void) {
  let valid = false;

  if (!formRef.value) return valid;

  await formRef.value.validate((v) => {
    if (v) {
      valid = true;
      callback && callback();
    }
  });

  return valid;
}

watchEffect(() => {
  if (props.visible) {
    nextTick(() => {
      formValues.value = {} as IYibaoBaseInfo & { code: string };
    });
  } else {
    formRef.value?.resetFields();
  }
});
</script>
